$( document ).ready(function() {

  // Show more/less module
  function showMore() {
    const showBoxContent = $('.js-showBox-content');
    const showBoxFt = '.js-showBox-ft';
    const showBoxBtn = '.js-showBox-btn';
    const showBoxLess = '.js-showBox-less';
    const showBoxMore = '.js-showBox-more';
    const height = showBoxContent.outerHeight();
    
    if (height > 101){
      showBoxContent.addClass('active');
      $(showBoxFt).show();
    }
    
    $(showBoxBtn).click(function(e) {
      $(this).parent(showBoxFt).prev(showBoxContent).toggleClass('active');
      $(this).find(showBoxMore).toggleClass('active');
      $(this).find(showBoxLess).toggleClass('active');
  
      e.preventDefault();
    });
  };
  
  showMore();

  // Display Newsletter Popup on click
  function newsletterPopup() {
    const popup = '#newsletter_overlay';
    const activate = '.newsletter_button';
    const deactivate = '.newsletter_modal_close';
    
    $(activate).click(function(e) {
      $(this).parents('body').find(popup).addClass('active');
      e.preventDefault();
    });

    $(deactivate).click(function(e) {
      $(this).parents(popup).removeClass('active');
      e.preventDefault();
    });
  };
  
  newsletterPopup();

  function hideOrichiPdp() {
    if ($('section.product__container').hasClass('b2b')) {
      setTimeout(() => {
        if ($('.orichi').length) {
          $('.orichi').addClass('titan-hide');
        }
      }, '500');

      setTimeout(() => {
        if ($('.orichi').length) {
          if (!$('.orichi').hasClass('titan-hide')) {
            $('.orichi').addClass('titan-hide');
          }
        }
      }, '1000');

      setTimeout(() => {
        if ($('.orichi').length) {
          if (!$('.orichi').hasClass('titan-hide')) {
            $('.orichi').addClass('titan-hide');
          }
        }
      }, '2000')
    }
  }

  function addBannerCheckoutListener() {
    setTimeout(() => {
      $('.atc-button--checkout').on('click', function(e) {
        e.preventDefault();
        window.location.href = '/checkout';
      })
    }, '500');

    setTimeout(() => {
      $('.atc-button--checkout').on('click', function (e) {
        e.preventDefault();
        window.location.href = '/checkout';
      })
    }, '1000');

    setTimeout(() => {
      $('.atc-button--checkout').on('click', function (e) {
        e.preventDefault();
        window.location.href = '/checkout';
      })
    }, '1500');

    setTimeout(() => {
      $('.atc-button--checkout').on('click', function (e) {
        e.preventDefault();
        window.location.href = '/checkout';
      })
    }, '2000');

    setTimeout(() => {
      $('.atc-button--checkout').on('click', function (e) {
        e.preventDefault();
        window.location.href = '/checkout';
      })
    }, '3000');
  }

  function redirectToCheckoutBanner() {
    if ($('.atc-banner--container').hasClass('b2b')) {
      $('.product-form--atc-button').on('click', function() {
        addBannerCheckoutListener();
      })
    }
  }

  if (document.location.href.includes('/products')) {
    hideOrichiPdp();
    redirectToCheckoutBanner();
  }

  function redirectToCheckout() {
    if ($('.cart--section form').hasClass('b2b')) {
      $('button[name="checkout"]').on('click', function(e) {
        e.preventDefault();
        window.location.href = '/checkout';
      })
    }
  }

  function hideOrichiCart() {
    if ($('.cart--section form').hasClass('b2b')) {
      setTimeout(() => {
        if ($('.orichi-subtotal').length) {
          $('.orichi-subtotal').addClass('titan-hide');
        }
      }, '500');

      setTimeout(() => {
        if ($('.orichi-subtotal').length && !$('.orichi-subtotal').hasClass('titan-hide')) {
          $('.orichi-subtotal').addClass('titan-hide');
        }
      }, '1000');

      setTimeout(() => {
        if ($('.orichi-subtotal').length && !$('.orichi-subtotal').hasClass('titan-hide')) {
          $('.orichi-subtotal').addClass('titan-hide');
        }
      }, '1500');

      setTimeout(() => {
        if ($('.orichi-subtotal').length && !$('.orichi-subtotal').hasClass('titan-hide')) {
          $('.orichi-subtotal').addClass('titan-hide');
        }
      }, '2000');
    }
  }

  if (document.location.href.includes('/cart')) {
    redirectToCheckout();
    hideOrichiCart();
  }
});